import styled from "styled-components";
import { paletas } from "../../../../../styles/theme";

export const Wrapper = styled.div`
  padding: 30px 20px;
  border-radius: 0.25rem;
  background: rgba(0, 0, 0, 0.1);

  h4,
  label {
    font-size: 1rem;
    font-weight: 500;
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
  }

  h4 {
    margin-bottom: 10px;
  }

  input {
    margin-right: 5px;
    cursor: pointer;
  }

  label {
    cursor: pointer;
  }

  div {
    margin: 5px 0;
  }

  input[type="radio"] {
    display: none;
    transition: all 0.25s;
  }
  input[type="radio"] + label span {
    display: inline-block;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    margin: -2px 10px 0 0;
    vertical-align: middle;
    border: 1px solid ${paletas.BlueLight};
    cursor: pointer;
    transition: all 0.25s;
  }
  input[type="radio"]:checked + label span {
    background: ${paletas.BlueLight};
    border: 1px solid ${paletas.BlueLight};
    transition: all 0.25s;
  }
  input[type="radio"]:disabled + label span {
    opacity: 0.5;
    transition: all 0.25s;
  }

  button {
    margin-top: 20px;
  }
`;
